<template>
  <div
    v-loading="answer_loading"
    element-loading-text="站点信息获取中..."
    class="bg"
    :style="{
      'background-image': background_line,
    }"
  >
    <!-- <el-image
      v-if="!rules_show && !answer_show"
      @click="btn_start"
      class="btn-start"
      style="width: 212px; height: 80px"
      :src="btn_img"
      fit="cover"
    ></el-image> -->
    <div style="position: relative" v-show="!rules_show && !answer_show">
      <div :class="{ login_box: true }">
        <div
          :style="{
            'background-color': header_background,
            color: btn_foreground,
          }"
          v-if="answer_title"
          class="header"
        >
          <div class="header-box">
            {{ answer_title }}
          </div>
        </div>
        <div class="login_flex">
          <div class="login_img">
            <el-image
              style="
                position: absolute;
                left: -32px;
                width: 216px;
                top: 35px;
                z-index: 1;
              "
              :src="img_logo_desktop || require('../../public/img/login.png')"
            ></el-image>
          </div>
          <div class="login_form" v-if="!answer_user">
            <el-form
              :hide-required-asterisk="false"
              label-position="right"
              label-width="100px"
              :model="form_state"
              :rules="register_form_rules"
              ref="register_form"
            >
              <el-form-item
                v-for="item in register_fields"
                :key="item"
                :label="item.name + '：'"
                :prop="item.name"
              >
                <el-input
                  v-if="['String', 'Number'].indexOf(item.type) > -1"
                  v-model="form_state[item.name]"
                  :type="item.type.toLowerCase()"
                  :placeholder="item.placeholder"
                  autocomplete="off"
                ></el-input>
                <el-select
                  style="width: 100%"
                  v-if="['Select'].indexOf(item.type) > -1"
                  v-model="form_state[item.name]"
                  filterable
                  :allow-create="true"
                  :default-first-option="true"
                  :placeholder="item.placeholder"
                >
                  <el-option
                    v-for="i in item.options.split(',')"
                    :key="i"
                    :label="i"
                    :value="i"
                  >
                  </el-option>
                </el-select>
                <el-cascader
                    v-if="['SSX'].indexOf(item.type) > -1"
                    style="width: 100%;"
                    :options="areaData"
                    v-model="form_state[item.name]"
                    filterable
                  :placeholder="item.placeholder"
                ></el-cascader>
              </el-form-item>
            </el-form>
            <el-row style="justify-content: flex-start; margin-left: 100px">
              <el-button
                :style="{
                  'background-color': background,
                  'border-color': background,
                }"
                @click="register_submit"
                type="primary"
                >开始答题</el-button
              >
            </el-row>
          </div>
          <div class="login_form" style="text-align: center" v-else>
            <label style="display: block; margin-bottom: 20px; margin-left: 100px; text-align: left;"
              >您好：{{ answer_user.name }}</label
            >
            <el-row style="justify-content: flex-start; margin-left: 100px">
              <el-button
                :style="{
                  'background-color': background,
                  'border-color': background,
                }"
                @click="btn_start"
                type="primary"
                >开始答题</el-button
              >
            </el-row>
          </div>
        </div>
      </div>
      <footer class="footer browser_tag_other" :style="{ clear: 'both' }">
        <div class="weui-desktop-foot__extra">
          <p class="copyright weui-desktop-link">
            {{ answer_host }}
            <!-- © 2021 中国核学会 魅力之光核科普知识竞赛 -->
          </p>
        </div>
      </footer>
    </div>
    <transition name="el-fade-in-linear">
      <div :class="{ rules_box: true }" v-show="rules_show">
        <h1>规则</h1>
        <p v-for="item in rules" :key="item">{{ item }}</p>
        <el-row>
          <el-button
            :style="{
              'background-color': background,
              'border-color': background,
            }"
            :loading="rules_loading"
            @click="rules_sure"
            type="primary"
            >我已阅读所有规则</el-button
          >
        </el-row>
      </div>
    </transition>
    <div :class="{ answer_box: true, hide: !answer_show }">
      <div class="answer_body">
        <el-tag>{{ question_type_str }}</el-tag>
        <div style="width: 80%">
          <div class="answer_ctn">
            <el-image
              :hide-on-click-modal="true"
              :preview-src-list="[question_analysisImage]"
              style="width: 300px; height: 168px"
              v-if="question_analysisImage"
              :src="question_analysisImage"
              fit="cover"
            >
              <template #placeholder>
                <div class="image-slot">加载中<span class="dot">...</span></div>
              </template>
            </el-image>
            <p class="answer_text">
              {{ question_index + 1 }}
              /
              {{ questions.length }}、
              {{ question_description }}
            </p>

            <div>
              <el-checkbox-group
                v-if="question_type === 1"
                class="answer_options"
                v-model="answers_selected"
              >
                <el-checkbox
                  v-for="item in question_options"
                  :key="item"
                  :label="item.id"
                  :disabled="question_complete"
                >
                  {{ item.item }}、{{ item.value }}
                </el-checkbox>
              </el-checkbox-group>
              <el-radio-group
                v-if="question_type === 0"
                class="answer_options"
                v-model="answer_selected"
              >
                <el-radio
                  v-for="item in question_options"
                  :key="item"
                  :label="item.id"
                  :disabled="question_complete"
                >
                  {{ item.item }}、{{ item.value }}
                </el-radio>
              </el-radio-group>
            </div>
            <el-button
              :style="{
                'background-color': background,
                'border-color': background,
              }"
              @click="answer_sure"
              class="answer_sure"
              type="primary"
              >确定</el-button
            >
            <el-button
              :style="{
                'background-color': background,
                'border-color': background,
              }"
              :loading="submit_loading"
              v-if="question_complete && answer_finish"
              @click="question_submit"
              class="question_submit"
              type="primary"
              >提交</el-button
            >
            <el-button
              :style="{
                'background-color': background,
                'border-color': background,
              }"
              v-else-if="question_complete && !answer_finish"
              @click="question_next"
              class="question_next"
              type="primary"
              >下一题</el-button
            >
          </div>
        </div>
      </div>
      <div class="answer_tip">
        <span class="span"
          >答对：<span style="color: #00c356">{{ right }}题</span></span
        >
        <span class="span"
          >答错：<span style="color: #ff664b">{{ wrong }}题</span></span
        >
        <span class="span"
          >正确率：<span
            ><span>{{ right_present }}%</span></span
          ></span
        >
      </div>
      <div :class="{ answer_analysis: true, hide: !analysis_show }">
        <h4>答案解析</h4>
        <p>
          <span style="font-weight: bolder">正确答案</span>：{{
            question_answer.join(",")
          }}
        </p>
        <p>试题解析：</p>
        <p>{{ question_analysis }}</p>
      </div>
    </div>
  </div>
  <el-dialog
    v-model="result_show"
    :lock-scroll="false"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="prize_box">
      <img :src="require('../../public/img/prize.png')" />
      <span style="position: absolute; top: 18px; font-size: 12px">答对</span>
      <span style="position: absolute; top: 35px"
        ><span style="font-size: 35px; margin-right: 5px">{{ right }}</span
        >题</span
      >
    </div>
    <div class="answer_tip center">
      <span class="span"
        >答对：<span style="color: #00c356">{{ right }}题</span></span
      >
      <span class="span"
        >答错：<span style="color: #ff664b">{{ wrong }}题</span></span
      >
      <span class="span"
        >正确率：<span
          ><span>{{ right_present }}%</span></span
        ></span
      >
    </div>
    <div class="center">
      <el-button
        v-if="has_redpack"
        :loading="redpack_loading"
        @click="get_redpack"
        style="margin-top: 25px"
        size="medium"
        type="danger"
        >抽取红包</el-button
      >
      <el-button
        :style="{
          'background-color': background,
          'border-color': background,
          'margin-top': '25px',
        }"
        @click="try_again"
        size="medium"
        type="primary"
        >再来一次</el-button
      >
      <el-button
        :style="{
          'background-color': background,
          'border-color': background,
          'margin-top': '25px',
        }"
        @click="close_web"
        size="medium"
        type="primary"
        >关闭退出</el-button
      >
    </div>
  </el-dialog>
  <el-dialog title="信息完善" v-model="register_show" :lock-scroll="false">
    <el-form
      label-position="right"
      label-width="100px"
      :model="form_state"
      :rules="register_form_rules"
      ref="register_form"
    >
      <el-form-item
        v-for="item in register_fields"
        :key="item"
        :label="item.name"
        :prop="item.name"
      >
        <el-input
          v-if="['String', 'Number'].indexOf(item.type) > -1"
          v-model="form_state[item.name]"
          :type="item.type.toLowerCase()"
          :placeholder="item.placeholder"
          autocomplete="off"
        ></el-input>
        <el-select
          style="width: 100%"
          v-if="['Select'].indexOf(item.type) > -1"
          v-model="form_state[item.name]"
          filterable
          :placeholder="item.placeholder"
        >
          <el-option
            v-for="i in item.options.split(',')"
            :key="i"
            :label="i"
            :value="i"
          >
          </el-option>
        </el-select>
        <elui-china-area-dht
          style="width: 100%"
          v-model="form_state[item.name]"
          :placeholder="item.placeholder"
          v-if="['SSX'].indexOf(item.type) > -1"
        ></elui-china-area-dht>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="register_show = false">取 消</el-button>
        <el-button
          :style="{
            'background-color': background,
            'border-color': background,
            'margin-top': '25px',
          }"
          :loading="register_loading"
          type="primary"
          @click="register_submit"
          >确 定</el-button
        >
      </span>
    </template>
  </el-dialog>
  <el-dialog
    custom-class="login_qrcode"
    ref="LoginQrCode"
    title="请使用微信扫描下方二维码登录"
    v-model="login_qrcode_show"
    :show-close="false"
    :lock-scroll="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
  </el-dialog>
</template>
<script>
import { defineComponent, inject, onMounted, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import {
  init,
  get_paper,
  submit_paper,
  send_redpack,
  reg_user,
  check_uid,
} from "../../api/index";
import config from "../../api/config";
import QRCode from "qrcodejs2";
import { EluiChinaAreaDht } from "elui-china-area-dht";
import { regionData } from 'element-china-area-data';
import area from '../../api/area';

const chinaData = new EluiChinaAreaDht.ChinaArea().chinaAreaflat;

export default defineComponent({
  components: {
    EluiChinaAreaDht,
  },
  setup() {
    const common = inject("common");
    const route = common.route;
    const query = route.query;

    let areaData = regionData;
    let site = query.site;
    if (['fef6bcba-08f6-4a5b-98fa-302b476e8ab4', 'e45b775a-5459-4fdd-81d2-330ebd4304ec', '784f962b-70b7-42e9-996b-4363ebc47ac6'].indexOf(site) > -1) {
      areaData = area.area;
    }

    const form_state = reactive({});

    const register_form_rules = ref({});

    const answer_user = ref(false);

    const LoginQrCode = ref(null);
    const register_form = ref(null);
    const register_fields = ref([]);

    const answer_host = ref("");
    const answer_title = ref("");
    const btn_img = ref("");
    const img_kv_desktop = ref("");
    const background = ref("#ffffff");
    const background_line = ref("#ffffff");
    const header_background = ref("#cccccc");
    const btn_foreground = ref("#000000");
    const img_logo_desktop = ref("");

    // 按钮加载状态
    const answer_loading = ref(true);
    const rules_loading = ref(false);
    const submit_loading = ref(false);
    const redpack_loading = ref(false);
    const register_loading = ref(false);
    // 是否显示答题界面、规则界面
    const login_show = ref(true);
    const answer_show = ref(false);
    const rules_show = ref(false);
    const analysis_show = ref(false);
    const result_show = ref(false);
    const register_show = ref(false);
    const has_redpack = ref(false);
    const login_qrcode_show = ref(false);
    // 规则列表
    const rules = ref([]);
    // 试题列表
    const questions = ref([]);
    const paper = ref(null);
    // 当前试题索引
    const question = ref(null);
    const question_index = ref(0);
    const question_description = ref("");
    const question_analysisImage = ref("");
    const question_analysis = ref("");
    const question_options = ref([]);
    const question_answer = ref([]);
    const question_answer_ids = ref([]);
    const question_type = ref(0);
    const question_type_str = ref(0);
    // 当前题目是否已做答
    const question_complete = ref(false);
    // 做答完成标记
    const answer_finish = ref(false);

    const answers_selected = ref([]);
    const answer_selected = ref("");

    // 对错题计数
    const right = ref(0);
    const wrong = ref(0);
    const right_present = ref(0);

    /**
     * 初始化题目
     **/
    const init_question = (q) => {

      // 初始化题目信息
      question.value = q;
      question_description.value = q.description.value;
      question_options.value = q.options;
      question_analysis.value = q.analysisText;
      question_analysisImage.value = q.analysisImage;
      question_type.value = q.type;
      switch(q.type) {
        case 0:
          question_type_str.value = "单选题";
          break;
        case 1:
          question_type_str.value = "多选题";
          break;
        default:
          question_type_str.value = "未知题型";
          break;
      }

      // 初始化答案信息
      let answers = [];
      let answers_ids = [];
      for (let i in q.options) {
        for (let j in q.answers) {
          if (q.options[i].id === q.answers[j].option_id) {
            answers.push(q.options[i].item);
            answers_ids.push(q.options[i].id);
          }
        }
      }
      question_answer.value = answers;
      question_answer_ids.value = answers_ids;

      // 隐藏题目解析
      analysis_show.value = false;
      // 答题状态置为 未作答
      question_complete.value = false;
      // 选项置空
      answer_selected.value = "";
      answers_selected.value = [];
      // 如果是最后一题，状态调整为做答完成（显示提交按钮，隐藏下一题按钮）
      if (question_index.value + 1 >= questions.value.length) {
        answer_finish.value = true;
      }
    };

    /**
     * 获取试卷
     **/
    const init_paper = (success = null) => {
      rules_loading.value = true;
      get_paper()
        .then((res) => {
          rules_loading.value = false;

          let data = res.data;
          let other = res.other;

          if (other && other.user) {
            answer_user.value = other.user;
          }
          if (res.user) {
            answer_user.value = res.user;
          }

          if (res.err !== 0) {
            // 未进行信息登记，弹出登记页面
            if (res.err === 5) {
              // register_show.value = true;
              return;
            }

            ElMessage.error(res.message);
            return;
          }

          paper.value = data;
          questions.value = data.questions;

          if (data.questions) {
            init_question(data.questions[question_index.value]);
          }

          if (typeof success === "function") {
            success();
          }
        })
        .catch((error) => {
          rules_loading.value = false;
          console.log(error);
        });
    };

    /**
     * 获取站点信息
     **/
    const init_info = () => {
      if (!query.obt) {
        if (query.uid) {
          let url = `http://${location.host}${
            config.baseUrl[config.mode]
          }/check_obt/${query.uid}`;
          console.log(url);
          var qrcode = new QRCode(LoginQrCode.value.dialogRef, {
            text: url, // 需要转换为二维码的内容
            width: 200,
            height: 200,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
          login_qrcode_show.value = true;

          let check_uid_interval = setInterval(() => {
            check_uid({
              uid: query.uid,
            })
              .then((res) => {
                if (res.code !== 1) {
                }
                res = res.data;
                url = `http://${location.host}${
                  config.baseUrl[config.mode]
                }/h5/pc/dist/index.html#/?site=${query.site}&obt=${res.obt}`;
                clearInterval(check_uid_interval);

                location.replace(url);
                common.reload();
              })
              .catch(() => {});
          }, 3000);
        } else {
          ElMessage.error({
            message: "非法链接，请重新进入",
            duration: 0,
            offset: 50,
          });
        }
        return false;
      }
      if (query.site && query.obt) {
        answer_loading.value = true;
        init(query.site, query.obt).then((res) => {
          answer_loading.value = false;
          if (res.code !== 1) {
            ElMessage.error(res.msg);
          } else {
            let data = res.data;
            if (data.user) {
              answer_user.value = data.user;
            }
            rules.value = data.rules;
            answer_title.value = data.answer.name;
            answer_host.value = data.answer.host;
            document.title = data.answer.name;
            btn_img.value = data.answer.btn_img;
            img_kv_desktop.value = data.answer.img_kv_desktop;
            background.value = data.answer.background;
            header_background.value = LightenDarkenColor(
              data.answer.background,
              -20
            );
            background_line.value = `linear-gradient(to bottom, ${
              data.answer.background
            }, ${LightenDarkenColor(data.answer.background, 140)}, ${
              data.answer.background
            }, ${data.answer.background})`;
            btn_foreground.value = data.answer.btn_foreground;
            img_logo_desktop.value = data.answer.img_logo_desktop;
            // rules_show.value = true;
            // 如果需要登记信息，初始化登记字段
            if (data.answer.register_fields) {
              register_fields.value = JSON.parse(data.answer.register_fields);
              //
              for (let i in register_fields.value) {
                form_state[register_fields.value[i].name] = "";
                // 生成登记字段规则
                if (register_fields.value[i].required) {
                  register_form_rules.value[register_fields.value[i].name] = {
                    required: true,
                    message: "不能为空",
                    trigger: "blur",
                  };
                }
              }
            }

            init_paper();
          }
        });
        return;
      }

      ElMessage.error("参数错误！");
    };

    onMounted(() => {
      init_info();
    });

    /**
     * 确认答案
     */
    const answer_sure = () => {
      if (question_complete.value) {
        ElMessage.warning("当前题目已做答");
        return false;
      }

      let answer = "";
      switch (question_type.value) {
        case 1:
          answer = answers_selected.value;
          break;
        default:
          answer = answer_selected.value;
          break;
      }
      if (typeof answer === "string" && answer !== "") {
        answer = [answer];
      }
      if (!answer.length) {
        ElMessage.warning("请选择");
        return false;
      }
      questions.value[question_index.value].answers = answer;
      if (
        answer.sort().join(",") === question_answer_ids.value.sort().join(",")
      ) {
        ElMessage.success("做答正确！");
        right.value++;
      } else {
        ElMessage.error("做答错误！");
        wrong.value++;
      }

      analysis_show.value = true;

      question_complete.value = true;

      right_present.value = (
        (right.value * 100) /
        (right.value + wrong.value || 1)
      ).toFixed(2);

      // setTimeout(() => {
      //   question_next();
      // }, 100);
    };

    /**
     * 下一题
     */
    const question_next = () => {
      if (!question_complete.value) {
        ElMessage.warning("当前题目未做答");
        return false;
      }

      let question_now = question_index.value + 1;
      if (question_now >= questions.value.length) {
        ElMessage.warning("当前题目已经是最后一题");
        return false;
      }

      question_index.value++;
      init_question(questions.value[question_index.value]);
    };

    /**
     * 完成阅读规则
     **/
    const rules_sure = () => {
      if (paper.value) {
        answer_show.value = true;
        rules_show.value = false;
      } else {
        init_paper(() => {
          answer_show.value = true;
          rules_show.value = false;
        });
      }
    };

    /**
     * 提交试卷
     */
    const question_submit = () => {
      submit_loading.value = true;
      paper.value.questions = questions.value;
      submit_paper({
        paper: JSON.stringify(paper.value),
      })
        .then((res) => {
          submit_loading.value = false;
          if (res.err !== 0) {
            ElMessage.error(res.message);
            return false;
          }
          // 显示结果
          result_show.value = true;
          // 是否显示红包按钮
          if (res.data.redpack) {
            has_redpack.value = true;
          }
        })
        .catch((error) => {
          submit_loading.value = false;
          console.log(error);
        });
    };

    /**
     * 抽取红包
     */
    const get_redpack = () => {
      redpack_loading.value = true;
      send_redpack()
        .then((res) => {
          redpack_loading.value = false;
          if (res.err !== 0) {
            ElMessage.error(res.message);

            if (res.other && res.other.reason === 0) {
              has_redpack.value = false;
            }

            return;
          }
          console.log(res);
        })
        .catch((error) => {
          redpack_loading.value = false;
          console.log(error);
        });
    };

    /**
     * 再来一次
     */
    const try_again = () => {
      location.reload();
    };

    /**
     * 登记信息提交
     */
    const register_submit = () => {
      console.log(register_form.value);
      register_form.value.validate((valid) => {
        if (valid) {
          let data = {};
          for (let i in form_state) {
            if (typeof form_state[i] === "object") {
              data[i] = [];
              for (let j in form_state[i]) {
                data[i].push(chinaData[form_state[i][j]].label);
              }
              data[i] = data[i].join(" ");
            } else {
              data[i] = form_state[i];
            }
          }
          register_loading.value = true;
          reg_user(data)
            .then((res) => {
              register_loading.value = false;

              if (res.err !== 0) {
                ElMessage.error(res.message);
                return false;
              }

              rules_show.value = true;
              // register_show.value = false;
              // rules_sure();
            })
            .catch((error) => {
              console.log(error);
              register_loading.value = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    // 关闭当前页面
    const close_web = () => {
      window.opener = null;
      window.open("", "_self");
      window.close();
    };

    // 展示规则
    const btn_start = () => {
      rules_show.value = true;
    };

    return {
      areaData,
      
      login_show,
      btn_start,
      close_web,
      LoginQrCode,
      register_form_rules,
      register_form,
      rules_loading,
      redpack_loading,
      submit_loading,
      register_loading,
      paper,
      answer_host,
      question,
      has_redpack,
      question_index,
      question_description,
      question_analysis,
      question_options,
      question_answer,
      answer_selected,
      answers_selected,
      question_analysisImage,
      question_type,
      question_type_str,
      answer_sure,
      questions,
      rules,
      rules_sure,
      answer_show,
      rules_show,
      analysis_show,
      register_show,
      result_show,
      question_next,
      right,
      wrong,
      right_present,
      question_complete,
      answer_finish,
      question_submit,
      get_redpack,
      try_again,
      answer_title,
      register_fields,
      login_qrcode_show,
      form_state,
      register_submit,
      btn_img,
      img_kv_desktop,
      background,
      btn_foreground,
      header_background,
      answer_user,
      answer_loading,
      background_line,
      img_logo_desktop,
    };
  },
});

function LightenDarkenColor(col, amt) {
  var usePound = false;
  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }
  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;
  if (r > 255) r = 255;
  else if (r < 0) r = 0;
  var b = ((num >> 8) & 0x00ff) + amt;
  if (b > 255) b = 255;
  else if (b < 0) b = 0;
  var g = (num & 0x0000ff) + amt;
  if (g > 255) g = 255;
  else if (g < 0) g = 0;
  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}
</script>

<style scoped>
.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #eceeed;
  padding-bottom: 30px;
  background-position: center;
  background-position-y: 60px;
}
.header {
  height: 60px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;
}
.header-box {
  max-width: 1000px;
  padding: 0 30px;
  margin: auto;
  height: 100%;
  line-height: 60px;
  font-size: 28px;
  font-weight: 600;
}
.rules_box,
.answer_box,
.login_box {
  background-color: #ffffff;
  max-height: 80vh;
  max-width: 1000px;
  padding: 20px 30px;
  margin: 70px auto;
  overflow: hidden;
  overflow-y: scroll;
  border-radius: 8px;
  box-shadow: -1px 0px 8px 1px #777;
  overflow: hidden;
  overflow-y: auto;
}
.login_box {
  max-width: 500px;
  overflow-y: hidden;
  border-radius: 8px;
  box-shadow: -1px 0px 8px 1px #777;
  padding: 75px 30px;
  position: relative;
  margin-top: 15vh;
}
.rules_box h1 {
  font-size: 23px;
}
.rules_box p {
  font-size: 14px;
}
.answer_body {
  display: flex;
  justify-content: flex-start;
  align-content: center;
}
.answer_ctn {
  margin-left: 20px;
}
.answer_options {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.answer_options .el-radio,
.answer_options .el-checkbox,
.answer_next,
.question_submit,
.answer_sure,
.answer_tip {
  margin-top: 20px;
}
.answer_tip .span {
  margin: 0 25px;
  white-space: nowrap;
}
.answer_analysis {
  border: 1px #ccc solid;
  margin-top: 20px;
  padding: 0 20px;
}
.answer_analysis p {
  color: #b79167;
}
.prize_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  margin: auto;
  position: relative;
  color: #ffffff;
}
.prize_box img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
}
.btn-start {
  position: absolute;
  left: 0;
  right: 0;
  top: 65vh;
  bottom: 0;
  margin: auto;
}
.login_flex {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.login_img {
  width: 30%;
  min-height: 250px;
}
.login_form {
  width: 70%;
  z-index: 2;
}
</style>
<style>
.login_qrcode img {
  margin: auto;
  padding: 33px;
}
.login_qrcode .el-dialog__body {
  padding: 0;
}
.footer {
  position: absolute;
  bottom: -60px;
  color: #fff;
  width: 100%;
  text-align: center;
  font-size: 10px;
}
.footer a {
  color: #fff;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 3px;
  height: 7px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
</style>